'use strict';

import taglineTemplate from './tagline.html';

export const taglineDirName = 'tagline';
export function taglineDir() {
  return {
    restrict: 'E',
    template: taglineTemplate
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/components/tagline/tagline.js